/**
 * CHECKBOX TOKENS
 */
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createCheckboxTokens(s: SemanticTokens) {
  return {
    /** Base sizing and layout */
    base: {
      radius: '5px', // --checkbox-base-radius (DS checkbox r5)
      size: '1.25rem', // --checkbox-base-size (20px box)
      borderWidth: '1.5px', // --checkbox-base-border-width
      iconSize: '11px', // --checkbox-base-icon-size (the check inside the box)
      focusShadowWidth: '2px', // --checkbox-base-focus-shadow-width
      transition: s.transition.normal, // --checkbox-base-transition
    },
    /** Secondary (default) variant */
    secondary: {
      unchecked: s.border.default, // --checkbox-secondary-unchecked: var(--border-default)
      checked: s.interactive.secondary.base, // --checkbox-secondary-checked: var(--interactive-secondary-base)
      hover: s.border.strong, // --checkbox-secondary-hover: var(--border-strong)
      checkedHover: s.interactive.secondary.hover, // --checkbox-secondary-checked-hover
      focus: s.focus.ring, // --checkbox-secondary-focus: var(--focus-ring)
    },
    /** Primary variant */
    primary: {
      unchecked: s.interactive.primary.base, // --checkbox-primary-unchecked
      checked: s.interactive.primary.base, // --checkbox-primary-checked
      hover: s.interactive.primary.hover, // --checkbox-primary-hover
      checkedHover: s.interactive.primary.hover, // --checkbox-primary-checked-hover
      focus: s.interactive.primary.subtle, // --checkbox-primary-focus
    },
    /** Surface variant (neutral) */
    surfaceVariant: {
      unchecked: s.interactive.neutral.subtle, // --checkbox-surface-unchecked
      checked: s.interactive.neutral.base, // --checkbox-surface-checked
      hover: s.interactive.neutral.subtleHover, // --checkbox-surface-hover
      checkedHover: s.interactive.neutral.hover, // --checkbox-surface-checked-hover
      focus: s.interactive.neutral.subtleFocus, // --checkbox-surface-focus
    },
    /** Success variant */
    success: {
      unchecked: s.interactive.success.base, // --checkbox-success-unchecked
      checked: s.interactive.success.base, // --checkbox-success-checked
      hover: s.interactive.success.hover, // --checkbox-success-hover
      checkedHover: s.interactive.success.hover, // --checkbox-success-checked-hover
      focus: s.states.success.bg, // --checkbox-success-focus
    },
    /** Danger variant */
    danger: {
      unchecked: s.interactive.danger.base, // --checkbox-danger-unchecked
      checked: s.interactive.danger.base, // --checkbox-danger-checked
      hover: s.interactive.danger.hover, // --checkbox-danger-hover
      checkedHover: s.interactive.danger.hover, // --checkbox-danger-checked-hover
      focus: s.states.danger.bg, // --checkbox-danger-focus
    },
    /** Warning variant */
    warning: {
      unchecked: s.interactive.warning.base, // --checkbox-warning-unchecked
      checked: s.interactive.warning.base, // --checkbox-warning-checked
      hover: s.interactive.warning.hover, // --checkbox-warning-hover
      checkedHover: s.interactive.warning.hover, // --checkbox-warning-checked-hover
      focus: s.states.warning.bg, // --checkbox-warning-focus
    },
    background: s.surface.ground, // --checkbox-background
    checkColor: s.text.onColor, // --checkbox-check-color
    disabled: s.surface.disabled, // --checkbox-disabled
    invalid: s.interactive.danger.hover, // --checkbox-invalid
  };
}
export const checkboxTokens = createCheckboxTokens(SEMANTIC);
